import React from 'react';
import _ from 'lodash';
import MetricLoader from '../MetricLoader';
import ComparisonMetric from '../ComparisonMetric';
import moment from 'moment-timezone';
import {useEventsContext} from '@/pages/dashboard/EventsContext';
import useCoreEventsMetrics from "@/hooks/useCoreEventsMetrics";

export default function StudentsYear(props) {
  const {network, schoolStart, titleOnly} = props;
  const {filteredEvents, isLoading, selectedSiteIds} = useEventsContext();

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousEvents = useCoreEventsMetrics({
    networkId: network?.id,
    startDate: titleOnly ? undefined : previousSchoolStart,
    endDate: schoolStart,
    pageSize: 1000,
  }, {enabled: titleOnly !== true});

  if ((titleOnly !== true && previousEvents.isLoading) || isLoading) {
    return (
      <MetricLoader
        name="Students Impacted"
      />
    );
  }

  const previousCount = _.reduce(previousEvents.data, function (result, event) {
    if (!event.completed) {
      return result;
    }

    if (event.students < 0 || event.students === null) {
      return result;
    }

    const siteId = event.siteId;
    if (selectedSiteIds.length > 0 && !selectedSiteIds.includes(siteId)) {
      return result;
    }
    return result + event.students;
  }, 0);

  const newCount = _.reduce(filteredEvents, function (result, event) {
    if (!event.completed) {
      return result;
    }

    return result + (event.students || 0);
  }, 0);

  return (
    <ComparisonMetric
      name="Students Impacted"
      value={newCount}
      previousValue={previousCount}
      titleOnly={titleOnly}
    />
  );
}
